import { render, staticRenderFns } from "./EmployeeSettingsSalaryGroup.vue?vue&type=template&id=1bafff56&"
import script from "./EmployeeSettingsSalaryGroup.vue?vue&type=script&lang=js&"
export * from "./EmployeeSettingsSalaryGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports